<template>
  <div class="container-wrapper">
    <div class="table-wrapper">
      <div class="px-4 font-semibold dark:text-white">Dashboard</div>
      <div class="card-body">
        <fwb-alert type="success">
          Selamat Datang <strong> {{ this.userFullName }}.</strong>
        </fwb-alert>

        <!-- Filter Section -->
        <div class="grid md:grid-cols-2 md:gap-4 py-2">
          <div class="py-1 col-span-2 md:col-span-1 flex">
            <div class="py-1">
              <button
                type="button"
                @click="this.fetchData()"
                class="btn btn-icon btn-gray"
              >
                <font-awesome-icon
                  :icon="['fas', 'arrows-rotate']"
                  :spin="isLoading"
                />
              </button>
            </div>
            <div class="py-1 col-span-2 md:col-span-1 flex">
              <InputSelect
                placeholder="Pilih Periode"
                v-model="filter.periode"
                :options="listPeriode"
                @change="this.fetchData()"
              />
            </div>
          </div>
        </div>

        <!-- Stats Cards - 4 cards baru untuk status pemberkasan -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-3">
          <!-- Card Total Pengajuan -->
          <div
            class="bg-white rounded-lg p-6 shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 dark:bg-gray-900 dark:border-gray-700"
          >
            <div class="flex items-start justify-between">
              <div class="p-3 bg-blue-50 rounded-xl dark:bg-blue-900/30">
                <font-awesome-icon
                  icon="users"
                  class="text-blue-600 dark:text-blue-400"
                />
              </div>
              <div class="text-right">
                <span
                  class="block text-2xl font-black text-slate-800 dark:text-white tracking-tight"
                >
                  {{ (count_mahasiswa || 0).toLocaleString() }}
                </span>
                <p
                  class="text-xs font-medium text-slate-400 uppercase tracking-wide"
                >
                  Jumlah Mahasiswa
                </p>
              </div>
            </div>
          </div>
          <div
            class="bg-white rounded-lg p-6 shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 dark:bg-gray-900 dark:border-gray-700"
          >
            <div class="flex items-start justify-between">
              <div class="p-3 bg-blue-50 rounded-xl dark:bg-blue-900/30">
                <font-awesome-icon
                  icon="users"
                  class="text-blue-600 dark:text-blue-400"
                />
              </div>
              <div class="text-right">
                <span
                  class="block text-2xl font-black text-slate-800 dark:text-white tracking-tight"
                >
                  {{ (status_summary.total || 0).toLocaleString() }}
                </span>
                <p
                  class="text-xs font-medium text-slate-400 uppercase tracking-wide"
                >
                  Total Pengajuan
                </p>
              </div>
            </div>
          </div>

          <!-- Card Ditolak -->
          <div
            class="bg-white rounded-lg p-6 shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 dark:bg-gray-900 dark:border-gray-700"
          >
            <div class="flex items-start justify-between">
              <div class="p-3 bg-red-50 rounded-xl dark:bg-red-900/30">
                <font-awesome-icon
                  icon="times-circle"
                  class="text-red-600 dark:text-red-400"
                />
              </div>
              <div class="text-right">
                <span
                  class="block text-2xl font-black text-slate-800 dark:text-white tracking-tight"
                >
                  {{ (status_summary.ditolak || 0).toLocaleString() }}
                </span>
                <p
                  class="text-xs font-medium text-slate-400 uppercase tracking-wide"
                >
                  Ditolak
                </p>
              </div>
            </div>
            <div class="mt-4 flex items-center gap-2">
              <div
                class="flex-1 h-1 bg-red-50 rounded-full overflow-hidden dark:bg-red-900/30"
              >
                <div
                  class="h-full bg-red-500"
                  :style="{ width: `${statusPercentages.ditolak || 0}%` }"
                ></div>
              </div>
              <span class="text-[10px] font-bold text-red-600"
                >{{ statusPercentages.ditolak || 0 }}%</span
              >
            </div>
          </div>

          <!-- Card Pemberkasan / Gagal Pemberkasan -->
          <div
            class="bg-white rounded-lg p-6 shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 dark:bg-gray-900 dark:border-gray-700"
          >
            <div class="flex items-start justify-between">
              <div
                :class="[
                  'p-3 rounded-xl',
                  pemberkasanLabel === 'Gagal Pemberkasan'
                    ? 'bg-orange-50 dark:bg-orange-900/30'
                    : 'bg-slate-50 dark:bg-slate-800',
                ]"
              >
                <font-awesome-icon
                  :icon="
                    pemberkasanLabel === 'Gagal Pemberkasan'
                      ? 'exclamation-triangle'
                      : 'file-alt'
                  "
                  :class="[
                    pemberkasanLabel === 'Gagal Pemberkasan'
                      ? 'text-orange-600 dark:text-orange-400'
                      : 'text-slate-600 dark:text-slate-400',
                  ]"
                />
              </div>
              <div class="text-right">
                <span
                  class="block text-2xl font-black text-slate-800 dark:text-white tracking-tight"
                >
                  {{ (status_summary.pemberkasan || 0).toLocaleString() }}
                </span>
                <p
                  class="text-xs font-medium text-slate-400 uppercase tracking-wide"
                >
                  {{ pemberkasanLabel }}
                </p>
              </div>
            </div>
            <div class="mt-4 flex items-center gap-2">
              <div
                :class="[
                  'flex-1 h-1 rounded-full overflow-hidden',
                  pemberkasanLabel === 'Gagal Pemberkasan'
                    ? 'bg-orange-50 dark:bg-orange-900/30'
                    : 'bg-slate-50 dark:bg-slate-800',
                ]"
              >
                <div
                  :class="[
                    'h-full',
                    pemberkasanLabel === 'Gagal Pemberkasan'
                      ? 'bg-orange-500'
                      : 'bg-slate-500',
                  ]"
                  :style="{ width: `${statusPercentages.pemberkasan || 0}%` }"
                ></div>
              </div>
              <span
                :class="[
                  'text-[10px] font-bold',
                  pemberkasanLabel === 'Gagal Pemberkasan'
                    ? 'text-orange-600'
                    : 'text-slate-600',
                ]"
              >
                {{ statusPercentages.pemberkasan || 0 }}%
              </span>
            </div>
          </div>

          <!-- Card Diterima -->
          <div
            class="bg-white rounded-lg p-6 shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 dark:bg-gray-900 dark:border-gray-700"
          >
            <div class="flex items-start justify-between">
              <div class="p-3 bg-emerald-50 rounded-xl dark:bg-emerald-900/30">
                <font-awesome-icon
                  icon="check-circle"
                  class="text-emerald-600 dark:text-emerald-400"
                />
              </div>
              <div class="text-right">
                <span
                  class="block text-2xl font-black text-slate-800 dark:text-white tracking-tight"
                >
                  {{ (status_summary.diterima || 0).toLocaleString() }}
                </span>
                <p
                  class="text-xs font-medium text-slate-400 uppercase tracking-wide"
                >
                  Diterima
                </p>
              </div>
            </div>
            <div class="mt-4 flex items-center gap-2">
              <div
                class="flex-1 h-1 bg-emerald-50 rounded-full overflow-hidden dark:bg-emerald-900/30"
              >
                <div
                  class="h-full bg-emerald-500"
                  :style="{ width: `${statusPercentages.diterima || 0}%` }"
                ></div>
              </div>
              <span class="text-[10px] font-bold text-emerald-600"
                >{{ statusPercentages.diterima || 0 }}%</span
              >
            </div>
          </div>
        </div>

        <!-- Visualisasi Progres Section -->
        <div
          class="bg-white rounded-lg shadow-sm border border-slate-100 p-8 mb-3 dark:bg-gray-900 dark:border-gray-700"
        >
          <div
            class="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4"
          >
            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
              Visualisasi Progres Pemberkasan
            </h3>
            <div class="flex flex-wrap gap-4">
              <div class="flex items-center gap-2">
                <span class="w-2 h-2 rounded-full bg-red-500"></span>
                <span class="text-[11px] font-medium text-slate-500 uppercase"
                  >Ditolak</span
                >
              </div>
              <div class="flex items-center gap-2">
                <span
                  :class="[
                    'w-2 h-2 rounded-full',
                    pemberkasanLabel === 'Gagal Pemberkasan'
                      ? 'bg-orange-500'
                      : 'bg-slate-500',
                  ]"
                ></span>
                <span
                  class="text-[11px] font-medium text-slate-500 uppercase"
                  >{{ pemberkasanLabel }}</span
                >
              </div>
              <div class="flex items-center gap-2">
                <span class="w-2 h-2 rounded-full bg-emerald-500"></span>
                <span class="text-[11px] font-medium text-slate-500 uppercase"
                  >Diterima</span
                >
              </div>
              <div class="flex items-center gap-2">
                <span class="w-2 h-2 rounded-full bg-green-600"></span>
                <span class="text-[11px] font-medium text-slate-500 uppercase"
                  >Selesai Cair</span
                >
              </div>
            </div>
          </div>

          <!-- Progress Bar Utama (4 segmen) -->
          <div
            class="h-4 w-full bg-slate-100 rounded-full flex overflow-hidden p-1 gap-1 dark:bg-gray-800"
          >
            <div
              class="h-full bg-red-500 rounded-full transition-all duration-1000"
              :style="{ width: `${statusPercentages.ditolak || 0}%` }"
            ></div>
            <div
              :class="[
                'h-full rounded-full transition-all duration-1000',
                pemberkasanLabel === 'Gagal Pemberkasan'
                  ? 'bg-orange-500'
                  : 'bg-slate-500',
              ]"
              :style="{ width: `${statusPercentages.pemberkasan || 0}%` }"
            ></div>
            <div
              class="h-full bg-emerald-500 rounded-full transition-all duration-1000"
              :style="{ width: `${statusPercentages.diterima || 0}%` }"
            ></div>
            <div
              class="h-full bg-green-600 rounded-full transition-all duration-1000"
              :style="{ width: `${statusPercentages.selesai_cair || 0}%` }"
            ></div>
          </div>

          <!-- Detail Statistik Grid -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
            <div class="text-center">
              <span class="block text-sm font-bold text-red-500">{{
                (status_summary.ditolak || 0).toLocaleString()
              }}</span>
              <span class="text-[10px] text-slate-400 uppercase font-bold"
                >Ditolak</span
              >
              <span class="block text-[9px] text-slate-300 mt-1"
                >{{ statusPercentages.ditolak || 0 }}%</span
              >
            </div>
            <div class="text-center">
              <span
                :class="[
                  'block text-sm font-bold',
                  pemberkasanLabel === 'Gagal Pemberkasan'
                    ? 'text-orange-600'
                    : 'text-slate-600',
                ]"
              >
                {{ (status_summary.pemberkasan || 0).toLocaleString() }}
              </span>
              <span class="text-[10px] text-slate-400 uppercase font-bold">{{
                pemberkasanLabel
              }}</span>
              <span class="block text-[9px] text-slate-300 mt-1"
                >{{ statusPercentages.pemberkasan || 0 }}%</span
              >
            </div>
            <div class="text-center">
              <span class="block text-sm font-bold text-emerald-600">{{
                (status_summary.diterima || 0).toLocaleString()
              }}</span>
              <span class="text-[10px] text-slate-400 uppercase font-bold"
                >Diterima</span
              >
              <span class="block text-[9px] text-slate-300 mt-1"
                >{{ statusPercentages.diterima || 0 }}%</span
              >
            </div>
            <div class="text-center">
              <span class="block text-sm font-bold text-green-600">{{
                (status_summary.selesai_cair || 0).toLocaleString()
              }}</span>
              <span class="text-[10px] text-slate-400 uppercase font-bold"
                >Selesai Cair</span
              >
              <span class="block text-[9px] text-slate-300 mt-1"
                >{{ statusPercentages.selesai_cair || 0 }}%</span
              >
            </div>
          </div>

          <!-- Info Detail Diterima -->
          <div class="mt-8 pt-6 border-t border-slate-100 dark:border-gray-700">
            <div class="flex flex-wrap gap-6 text-xs">
              <div class="flex items-center gap-2">
                <div class="w-2 h-2 rounded-full bg-emerald-400"></div>
                <span class="text-slate-500">Pengajuan Diterima (5)</span>
                <span
                  class="font-bold text-slate-700 dark:text-gray-300 ml-1"
                  >{{
                    (status_summary.pengajuan_diterima || 0).toLocaleString()
                  }}</span
                >
              </div>
              <div class="flex items-center gap-2">
                <div class="w-2 h-2 rounded-full bg-pink-400"></div>
                <span class="text-slate-500">Rekening Tidak Sesuai (6)</span>
                <span
                  class="font-bold text-slate-700 dark:text-gray-300 ml-1"
                  >{{
                    (status_summary.rekening_tidak_sesuai || 0).toLocaleString()
                  }}</span
                >
              </div>
              <div class="flex items-center gap-2">
                <div class="w-2 h-2 rounded-full bg-blue-400"></div>
                <span class="text-slate-500">Berkas Lengkap (7)</span>
                <span
                  class="font-bold text-slate-700 dark:text-gray-300 ml-1"
                  >{{
                    (status_summary.berkas_lengkap || 0).toLocaleString()
                  }}</span
                >
              </div>
              <div class="flex items-center gap-2">
                <div class="w-2 h-2 rounded-full bg-indigo-400"></div>
                <span class="text-slate-500">Siap Pencairan (8)</span>
                <span
                  class="font-bold text-slate-700 dark:text-gray-300 ml-1"
                  >{{
                    (status_summary.siap_pencairan || 0).toLocaleString()
                  }}</span
                >
              </div>
            </div>
            <div
              class="mt-3 p-3 bg-emerald-50 rounded-lg dark:bg-emerald-900/20"
            >
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <font-awesome-icon
                    icon="check-circle"
                    class="text-emerald-600 text-sm"
                  />
                  <span
                    class="text-xs font-medium text-emerald-800 dark:text-emerald-300"
                    >Total Penerima Manfaat (Status 5-9)</span
                  >
                </div>
                <span
                  class="text-xl font-bold text-emerald-700 dark:text-emerald-400"
                  >{{ (status_summary.diterima || 0).toLocaleString() }}</span
                >
              </div>
              <div
                class="w-full bg-emerald-200 rounded-full h-1.5 mt-2 dark:bg-emerald-800"
              >
                <div
                  class="bg-emerald-600 h-1.5 rounded-full transition-all duration-500"
                  :style="{
                    width: `${
                      (status_summary.diterima / status_summary.total) * 100 ||
                      0
                    }%`,
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Existing Stats Cards (Jumlah Mahasiswa, dll) -->

        <!-- Charts -->
        <div v-show="!isLoading">
          <div
            class="mt-4 relative overflow-x-auto shadow-md rounded-md sm:rounded-lg"
          >
            <div ref="barKecamatan" class="rounded-lg"></div>
          </div>
          <div
            class="mt-4 relative overflow-x-auto shadow-md rounded-md sm:rounded-lg"
          >
            <div
              ref="barKampus"
              class="rounded-lg"
              style="min-height: 200vh"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./dashboard-page.js"></script>